import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Obserwujący',
  fields: {
    name: 'Nazwa',
    subscribed: 'Subskrybowany',
    followed: 'Obserwuje od',
    phone: 'Telefon',
    recent_order: 'Ostatnie zamówienie',
    total_orders: 'Łączne zamówienia',
    birthday: 'Data urodzenia',
    google_review: 'Recenzja Google',
    marketing_subscription_source: 'Subskrybowany z',
    loyalty_points: 'Lojalność',
  },
  empty_list: 'Brak klientów',
  yes: 'Tak',
  no: 'Nie',
  buttons: {
    import: 'Import',
    export: 'Eksport',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
  labels: {
    followed_since_date: 'Od {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
